
/* eslint-disable */
export const getLookOptionsForADropdown = (
  type,
  profileCreationAllLookupData
) => {
  if (profileCreationAllLookupData && profileCreationAllLookupData.length > 0)
    return profileCreationAllLookupData.filter((option) => {
      return option.type === type;
    });
};

export const getLookupOptionLabel = (id, profileCreationAllLookupData) => {
  let lookupRow =
    profileCreationAllLookupData &&
    profileCreationAllLookupData.lookupOptionDtoList &&
    profileCreationAllLookupData.lookupOptionDtoList.find((row, index) => {
      return row.id === Number(id);
    });
  return lookupRow ? lookupRow.label : "-";
};


export const getLookupOptionLabelNew = (id, profileCreationAllLookupData) => {
  let lookupRow =
    profileCreationAllLookupData &&
    profileCreationAllLookupData.find((row, index) => {
      return row.id === Number(id);
    });
  return lookupRow ? lookupRow.label : "-";
};
export const getDropdownOptionLabel = (value, myDropdownOptions) => {
  let selectedOption = myDropdownOptions.find((element) => {
    return element.value === value;
  });
  return selectedOption ? selectedOption.label : "";
};

export const getDropdownOptionForFullTime = (id) => {
  if (id == 1) {
    return "Full Time";
  }
  if (id == 2) {
    return "Otherwise";
  }
};

export const getDropdownForBpscSelection = (value) => {
  if (value === false || value === "false") {
    return "No";
  }
  if (value === true || value === "true") {
    return "Yes";
  }
};

export const nameOfIndexingBodies = (
  indexingBodyLookupId,
  nameOfIndexingBodiesList
) => {
  const foundItem =
    nameOfIndexingBodiesList && nameOfIndexingBodiesList.lookupOptionDtoList &&
    nameOfIndexingBodiesList.lookupOptionDtoList.length > 0 &&
    nameOfIndexingBodiesList.lookupOptionDtoList.find((item) => item.id == indexingBodyLookupId);
  return foundItem ? foundItem.label : "NA";
};

export const articleType = (
  articleTypeLookupId,
  getPublicationArticleTypeList
) => {
  const foundItem =
    getPublicationArticleTypeList && getPublicationArticleTypeList.lookupOptionDtoList &&
    getPublicationArticleTypeList.lookupOptionDtoList.length > 0 &&
    getPublicationArticleTypeList.lookupOptionDtoList.find(
      (item) => item.id == articleTypeLookupId
    );
  return foundItem ? foundItem.label : "NA";
};

export const flgPublicationFirstAuthor = (value, BOOLEAN_OPTION) => {
  const foundItem = BOOLEAN_OPTION.find((item) => item.value === value);
  return foundItem ? foundItem.label : "";
};
export const isPublicationFirstAuthor = (value, BOOLEAN_OPTION) => {
  const foundItem = BOOLEAN_OPTION.find((item) => item.value === value);
  return foundItem ? foundItem.label : "";
};

export const authorType = (value, AUTHOR_TYPES) => {
  const foundItem =
    AUTHOR_TYPES &&
    AUTHOR_TYPES.length > 0 &&
    AUTHOR_TYPES.find((item) => item.value == value);
  return foundItem ? foundItem.label : "";
};


export const examStaffDataDownloadFile = (error, fileName) => {
  const a = document.createElement('a');
  a.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(error));
  a.setAttribute('hidden', '')
  a.setAttribute('download', `${fileName}.csv`)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
};

export const examStaffDataJsonToCsv = (error) => {
  const csvRows = [];
  const headers = Object.keys(error[0].venue);
  // setexamStaffCsvHeader(headers);
  csvRows.push(headers.join(','))
  for (let i = 0; i < error.length; i++) {
    for (const row of Object.values(error[i])) {
      const values = headers.map(header => {
        const escaped = ('' + row[header]).replace(/"/g, '\\"')
        return `"${escaped}"`
      });
      csvRows.push(values.join(','))
    }
  }
  return csvRows.join('\n');
};